import { observer } from 'mobx-react';
import { FC } from 'react';
import { CandidateWithAge } from '~/definitions/candidate';
import ActionButtons from './ActionButtons/ActionButtons';
import { getStore } from '~/mobx/AppStore';
interface Props {
    data: CandidateWithAge;
    isViewCandidateOnly?: boolean;
    showJobPositionAndCity?: string;
}

const CandidateCard: FC<Props> = (props: Props) => {
    const {
        data: {
            id,
            priority,
            gender,
            firstName,
            lastName,
            age,
            city,
            jobPosition,
            slogan,
            description,
            cumulation,
            asset,
        },
        isViewCandidateOnly = false,
        showJobPositionAndCity = 'all',
    } = props;

    const noImage = { backgroundImage: `url('/img/candidate-${gender}.jpg')` };
    const image = asset ? { backgroundImage: `url(${asset}?w=208&h=208&f=jpg)` } : noImage;
    const priorityNumber = !isViewCandidateOnly && Number(priority) > 0 ? priority : '';
    const cumulationText = !isViewCandidateOnly && cumulation ? 'Forhåndskumulert' : '';
    const fullName = `${firstName} ${lastName}`;
    const ageText = age && age > 0 ? ` (${age})` : '';
    let jobPositionAndCityText = '';
    const separator = jobPosition && city ? ', ' : '';
    if (showJobPositionAndCity === 'all') jobPositionAndCityText = `${city}${separator}${jobPosition}`;
    if (showJobPositionAndCity === 'city') jobPositionAndCityText = city;
    if (showJobPositionAndCity === 'jobPosition') jobPositionAndCityText = jobPosition;

    const candidateCardClassNames = `candidate-card flex flex-col mb-4 min-h-[350px] w-full`;
    const candidateCardMDClassNames = `md:basis-1/2 md:min-h-[280px]`;
    const candidateCardFullClassNames = `${candidateCardClassNames} ${candidateCardMDClassNames}`;
    const candidateBorderClassNames = `candidate rounded-[8px] border border-custom-grey-4`;
    const candidateClassNames = `mx-[10px] mt-[15px] h-full bg-white p-4 text-sm shadow-sm`;
    const candidateFullClassNames = `${candidateBorderClassNames} ${candidateClassNames}`;
    const candidateNumberClassNames = `candidate-number flex flex-wrap justify-between min-h-[25px]`;
    const candidatePriorityClassNames = `candidate-priority level-plain font-bold`;
    const candidateTextClassNames = `text-sm md:text-base`;
    const profileClassNames = `profile-wrapper flex`;
    const profileMDClassNames = `md:min-h-[126px]`;
    const profileFullClassNames = `${profileClassNames} ${profileMDClassNames}`;
    const pictureProfileClassNames = `picture-profile flex-[0_0_100px] relative`;
    const pictureProfileMDClassNames = `md:basis-[120px]`;
    const pictureProfileFullClassNames = `${pictureProfileClassNames} ${pictureProfileMDClassNames}`;
    const imgClassNames = `img h-[126px] bg-no-repeat bg-[size:cover] bg-center`;
    const imgFullClassNames = `${imgClassNames}`;
    const detailProfileClassNames = `detail-profile ml-[10px] flex flex-1 flex-col md:min-h-[155px]`;
    const headingClassNames = `heading font-coopGroteskBold text-[1.2em] mb-0`;
    const jobClassNames = `job mb-2 italic`;
    const sloganClassNames = `slogan text-[.9em] mb-2`;
    const descriptionClassNames = `description mt-[10px] text-[1em] leading-normal`;
    const descriptionMDClassNames = `md:mt-[15px]`;
    const descriptionFullClassNames = `${descriptionClassNames} ${descriptionMDClassNames}`;

    return (
        <div className={candidateCardFullClassNames}>
            <div className={candidateFullClassNames}>
                {!isViewCandidateOnly && (
                    <div className={candidateNumberClassNames}>
                        <span className={`${candidatePriorityClassNames} ${candidateTextClassNames}`}>
                            {priorityNumber}
                        </span>
                        <span className={`${candidateTextClassNames} italic`}>{cumulationText}</span>
                    </div>
                )}
                <div className={profileFullClassNames}>
                    <div className={pictureProfileFullClassNames}>
                        <div className={imgFullClassNames} style={image} />
                    </div>
                    <div className={detailProfileClassNames}>
                        <h2 className={headingClassNames}>{fullName + ageText}</h2>
                        <div className={jobClassNames}>{jobPositionAndCityText}</div>
                        <div className="mt-auto">
                            <div className={sloganClassNames}>{slogan}</div>
                            {!isViewCandidateOnly && <ActionButtons candidateId={id} />}
                        </div>
                    </div>
                </div>
                <div className={descriptionFullClassNames}>{description}</div>
            </div>
        </div>
    );
};

const CandidateCardWithStore = (props: Props) => {
    const { ballotStore, candidateStore } = getStore();
    const { isViewCandidateOnly } = candidateStore;
    const { showJobPositionAndCity } = ballotStore;

    return (
        <CandidateCard
            data={props.data}
            isViewCandidateOnly={isViewCandidateOnly}
            showJobPositionAndCity={showJobPositionAndCity}
        />
    );
};

export default observer(CandidateCardWithStore);
